<template>
  <div class="vx-popup-share" v-if="opened" @click="close">
    <img class="b1" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/share/005.png" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    show(opts) {
      this.opened = true;
      return new Promise(resolve => {
        this._resolve = resolve;
      });
    },
    close() {
      this.opened = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.vx-popup-share {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  overflow: auto;
  z-index: 99999;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 4px;
  .b1 {
    display: block;
    width: 100%;
  }
}
</style>
